import {gql} from '@apollo/client'

export const CREATE_USER = gql`
  mutation userCreate($input: UserCreateInput!) {
    userCreate(input: $input) {
      success
      errors {
        message
      }
      user {
        id
      }
    }
  }
`

export const EDIT_USER = gql`
  mutation userUpdate($input: UserUpdateInput!) {
    userUpdate(input: $input) {
      success
      errors {
        message
      }
      user {
        id
      }
    }
  }
`

export const EDIT_PASSWORD_USER_FROM_ADMIN = gql`
  mutation userChangePassword($input: UserChangePasswordInput!) {
    userChangePassword(input: $input) {
      success
      errors {
        message
      }
    }
  }
`

export const ACTIVE_INACTIVE_USER = gql`
  mutation userInactivateActivate($input: UserDeactivateInput!) {
    userInactivateActivate(input: $input) {
      success
      errors {
        message
      }
    }
  }
`

export const ADD_EDIT_VALIDATION = gql`
  mutation identityValidationCreateUpdate($input: IdentityValidationCreateUpdateMutationInput!) {
    identityValidationCreateUpdate(input: $input) {
      identityValidation {
        id
      }
      errors {
        messages
      }
    }
  }
`
